import React from 'react';
import { useDisbursementType } from './useDisbursementTypes';
import { IDisbursementFormData } from 'types/order/escrow/IDisbursementFormData';
import { IDisbursementType } from './IDisbursementType';
import { eDisbursementType } from 'types/order/escrow/eDisbursementType';
import { ICreateSettlementFeeForm } from 'types/order/fees/ICreateSettlementItemForm';
import { BaseDisbursementContainer } from './BaseDisbursementContainer/BaseDisbursementContainer';

export interface IDisbursementFormProps {
  disbursement: IDisbursementFormData;
  disbursements: IDisbursementFormData[];
  onRemove?: () => void;
  onPush: (value: IDisbursementFormData) => void;
  disbursementTypes: IDisbursementType[];
  fee: ICreateSettlementFeeForm;
  isDirty: boolean;
  isSubmitting: boolean;
  hasErrors: boolean;
  feeName: string;
}

export const DisbursementForm: React.FC<IDisbursementFormProps> = ({
  disbursement,
  disbursements,
  onPush,
  onRemove,
  disbursementTypes,
  fee,
  feeName,
  isDirty,
  isSubmitting,
  hasErrors,
}) => {
  const disbursementType = useDisbursementType(disbursement.type);
  const disbursementOptions = disbursementTypes.filter((t) => t.hasEditPermission);
  return (
    <>
      {disbursementType?.hasReadPermission && (
        <BaseDisbursementContainer
          fee={fee}
          disbursements={disbursements}
          feeName={feeName}
          push={onPush}
          disbursementOptions={disbursementOptions}
          isSubmitting={isSubmitting}
          disbursementType={disbursementType}
          isDirty={isDirty}
          hasErrors={hasErrors}
          onRemove={onRemove}
          isCollapsible={disbursement.type === eDisbursementType.Check && !!disbursement.voidedAt}
        >
          {({ TypeChange, isCardCollapsed }) => (
            <disbursementType.container
              disbursementType={disbursementType}
              isDirty={isDirty}
              isSubmitting={isSubmitting}
              TypeChange={TypeChange}
              isCardCollapsed={isCardCollapsed}
            />
          )}
        </BaseDisbursementContainer>
      )}
    </>
  );
};
